import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import topTitle from '@/components/title';
import { getPersonnelDetail, personnelDetailEdit, getOccupationResource } from '../request';
import { isCardNo } from '@/utils/validate';
import moment from 'moment';
export default {
  props: {
    personEditVisible: {
      type: Boolean,
      default: false
    },
    editInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    topTitle
  },
  data() {
    return {
      form: {},
      loading: false,
      identificationTypeData: [{
        label: '身份证',
        value: 'IDCARD'
      }],
      defaultValue: moment('00:00:00', 'HH:mm:ss'),
      professionInfo: [{
        id: 1,
        customerInsuranceId: 102,
        jobNumber: 1,
        occupation: '保安'
      }],
      policyInfo: {}
    };
  },
  computed: {
    rules() {
      return {
        jobNumber: [{
          required: true,
          message: this.$t('请选择') + this.$t('工种'),
          trigger: 'change'
        }],
        identificationType: [{
          required: true,
          message: this.$t('请选择') + this.$t('证件类型'),
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('名称'),
          trigger: 'blur'
        }, {
          min: 2,
          max: 15,
          message: this.$t('请输入长度2-15的内容'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        startAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('签约日期')
        }],
        idNumber: [{
          required: true,
          message: this.$t('请输入') + this.$t('证件号码'),
          trigger: 'blur'
        }, {
          validator: this.validateCard,
          trigger: 'blur'
        }],
        remark: [{
          max: 200,
          message: this.$t('请输入长度200以内的内容'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }]
      };
    }
  },
  watch: {
    personEditVisible: {
      handler(newVal) {
        if (!newVal) return;
        this.$refs.dataFrom && this.$refs.dataFrom.resetFields();
        let params = {
          policyId: this.$route.params.id,
          personnelDetailsId: this.editInfo.id
        };
        getPersonnelDetail(params).then(res => {
          if (res.insuranceInfo) {
            this.policyInfo = res.insuranceInfo;
            if (Object.keys(this.policyInfo).length > 0) {
              const {
                policyNo,
                insuranceName,
                startAt,
                endAt,
                planId,
                insurancePlanName,
                customerInsuranceId
              } = this.policyInfo;
              this.form = {
                policyNo: policyNo,
                insuranceName: insuranceName,
                beginTime: startAt,
                endTime: endAt,
                planId: planId,
                insurancePlanName: insurancePlanName
              };
              this.getOccupationData(customerInsuranceId);
            }
          }
          if (res.insuredInfo) {
            const {
              name,
              jobNumber,
              identificationReallyType,
              idNumber,
              startAt,
              premium,
              remark
            } = res.insuredInfo;
            this.$set(this.form, 'name', name);
            this.$set(this.form, 'jobNumber', jobNumber);
            this.$set(this.form, 'idNumber', idNumber);
            this.$set(this.form, 'startAt', startAt);
            this.$set(this.form, 'premium', premium);
            this.$set(this.form, 'remark', remark);
            this.$set(this.form, 'identificationType', identificationReallyType);
          }
        });
      }
    }
  },
  methods: {
    validateCard(rule, idcard, callback) {
      let idcardTrim = (idcard === null || idcard === void 0 ? void 0 : idcard.trim()) || '';
      if (!isCardNo(idcardTrim) || idcardTrim == '') {
        callback(new Error(this.$t('请输入正确的身份证号')));
      } else {
        callback();
      }
    },
    async getOccupationData(customerInsuranceId) {
      //获取保安工种
      const res = await getOccupationResource({
        customerInsuranceId
      });
      if (res.length > 0) {
        this.professionInfo = res;
      }
      if (this.professionInfo.length === 1) {
        this.$set(this.form, 'jobNumber', this.professionInfo[0].jobNumber);
      }
    },
    onSubmit() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          const {
            jobNumber,
            name,
            identificationType,
            idNumber,
            startAt,
            premium,
            remark
          } = this.form;
          if (!premium) {
            this.$message.error(this.$t('保费为空'));
            return;
          }
          let selectOccupation = this.professionInfo.filter(item => item.jobNumber === jobNumber);
          let occupation = selectOccupation.length > 0 ? selectOccupation[0].occupation : '';
          let obj = {
            personnelDetailsId: this.editInfo.id,
            policyId: this.policyInfo.id,
            jobNumber,
            occupation,
            name: name ? name.trim() : '',
            identificationType,
            idNumber: idNumber ? idNumber.trim() : '',
            startAt,
            premium,
            remark: remark ? remark === null || remark === void 0 ? void 0 : remark.trim() : ''
          };
          personnelDetailEdit(obj).then(res => {
            this.$emit('refreshList');
            this.$emit('update:personEditVisible', false);
          });
        }
      });
    },
    onChangeTime(time) {
      let startAt = moment(time).add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
      this.$set(this.form, 'startAt', startAt);
    },
    disabledDate(current) {
      let start = moment().subtract(1, 'month').subtract(1, 'day');
      return current && current > moment().endOf('day') || current < start.endOf('day');
    },
    handlerCancel() {
      this.$emit('update:personEditVisible', false);
    }
  }
};